import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  border-radius: 1rem;
  margin: 0;
  width: 100%;
  height: 100%;
  
  @media (max-width: 534px) {
    margin: 0;
  }

  h1 {
    display: flex;
    align-items: center;
    font-size: 16px !important;
    margin: 0 !important;
    color: ${({ theme }) => theme.colors.secondary};
    gap: 0.2rem;
  }

  .diamondIcon {
    display: grid;
    flex-direction: column;
    align-items: center;
    width: 1.1rem;
    height: 1.1rem;
    fill: #363434;

    &.DIAMOND {
      fill: #97cfe8;
    }

    &.GOLD {
      fill: #e1dd75;
    }

    &.SILVER {
      fill: #b0b0b0;
    }

    &.BRONZE {
      fill: #d0a35f;
    }
  }

  .content-star {
    display: flex;
    gap: 0.4rem;
  }

  .content-icons-header {
    display: flex;
    gap: 0.3rem;
  }

  .remove-from-list {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    transition: opacity 0.2s;
    margin: 0;
    padding: 0;

    :hover {
      opacity: 0.55;
    }

    svg {
      width: 1rem;
      height: 1rem;
      margin: 0.2rem;
    }
  }

  .view-user {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    border-radius: 100%;
    color: ${({ theme }) => theme.colors.tertiary_500};
    transition: opacity 0.2s;

    :hover {
      opacity: 0.55;
    }

    svg {
      width: 1.2rem;
      height: 1.2rem;
      margin: 0.2rem;
    }
  }

  .containerCard .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    min-height: 1.5rem;

    h1 {
      font-size: 0.9rem !important;
      margin: 0 !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 60%;
      
      @media (max-width: 768px) {
        font-size: 0.8rem !important;
        max-width: 50%;
      }
      
      @media (max-width: 534px) {
        font-size: 0.75rem !important;
        max-width: 45%;
      }
    }

    .verified {
      width: 0.8rem;
      height: 0.8rem;
      flex-shrink: 0;
      
      @media (max-width: 534px) {
        width: 0.6rem;
        height: 0.6rem;
      }
    }
  }

  .content-buttons-options {
    padding: 0 0.4rem;
  }

  .content-button-flex-end {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 0.5rem;
    flex-shrink: 0;
    
    @media (max-width: 768px) {
      margin-top: 0.3rem;
    }
    
    @media (max-width: 534px) {
      margin-top: 0.2rem;
    }
  }

  .message-card-user {
    max-width: 7rem;
    height: 1.5rem;
    display: flex;
    justify-content: flex-start;
    text-decoration: underline;
    border: none;
    justify-content: center;
    font-weight: lighter;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.tertiary_500};
    transition: opacity 0.2s;
    margin: 0;
    padding: 0;

    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
      margin-right: 0.2rem;
    }

    :hover {
      opacity: 0.75;
    }
  }

  .content-buttons {
    margin-top: 0.5rem;
    height: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 0.3rem;
    flex-shrink: 0;
    
    @media (max-width: 768px) {
      margin-top: 0.3rem;
      gap: 0.2rem;
    }
    
    @media (max-width: 534px) {
      margin-top: 0.2rem;
      gap: 0.1rem;
    }

    .button-solicitation {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .content-button-flex-end {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    height: 1.5rem;

    .add-contact-from-to-list {
      display: flex;
      margin-right: 2rem;
    }
  }

  @media (max-width: 310px) {
    margin-left: 2.5rem;
  }
`;

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;
  width: 100%;
  min-height: 120px;
  max-height: 120px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    min-height: 100px;
    max-height: 100px;
  }
  
  @media (max-width: 534px) {
    min-height: 90px;
    max-height: 90px;
  }
  
  &.displayNone {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  flex: 1;
  padding: 0.5rem;
  
  @media (max-width: 768px) {
    padding: 0.4rem;
  }
  
  @media (max-width: 534px) {
    padding: 0.3rem;
  }

  .pictureImage {
    margin: 0;
    flex-shrink: 0;
    
    img {
      border-radius: 100%;
      min-height: 3rem;
      min-width: 3rem;
      max-height: 3rem;
      max-width: 3rem;
      
      @media (max-width: 768px) {
        min-height: 2.5rem;
        min-width: 2.5rem;
        max-height: 2.5rem;
        max-width: 2.5rem;
      }
      
      @media (max-width: 534px) {
        min-height: 2rem;
        min-width: 2rem;
        max-height: 2rem;
        max-width: 2rem;
      }
    }
  }

  .containerCard {
    flex-direction: column;
    padding: 0 0.5rem;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-between;
    min-height: 0;
    
    @media (max-width: 768px) {
      padding: 0 0.3rem;
    }
    
    @media (max-width: 534px) {
      padding: 0 0.2rem;
    }
  }

  .main {
    display: flex;
    gap: 0.5rem;

    p {
      width: 90%;
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.text_gray};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .serviceCard {
    display: flex;
    margin-top: 0.5rem;
    margin-right: 4rem;
    margin-left: 0.3rem;
    margin-bottom: 0.5rem;

    .numberServices {
      color: ${({ theme }) => theme.colors.primary};
      margin-left: 0.2rem;
    }

    .labelCorrespondence {
      color: ${({ theme }) => theme.colors.gray_300};
      margin-left: 0.2rem;
    }
  }
  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.3rem 0 0 0;
    flex-shrink: 0;
    
    @media (max-width: 768px) {
      margin: 0.2rem 0 0 0;
    }
    
    @media (max-width: 534px) {
      margin: 0.1rem 0 0 0;
    }
    
    span {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 0.8rem;
      
      @media (max-width: 534px) {
        font-size: 0.7rem;
      }
    }
    .btn-container {
      display: flex;
      align-items: center;
      gap: 0.3rem;
      margin: 0;
      
      @media (max-width: 768px) {
        gap: 0.2rem;
      }
      
      @media (max-width: 534px) {
        gap: 0.1rem;
      }
    }
    .btn-container-left {
      width: 100%;
      justify-content: flex-end;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .diamondCard {
      display: flex;
      margin: 0;
      padding: 0;
      height: 1.5rem;
      width: 1.5rem;
      flex-shrink: 0;
      
      @media (max-width: 768px) {
        height: 1.3rem;
        width: 1.3rem;
      }
      
      @media (max-width: 534px) {
        height: 1.1rem;
        width: 1.1rem;
      }
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    @media (max-width: 560px) {
      row-gap: 0.3rem;
      align-items: flex-start;
      flex-direction: column;
    }
  }

  @media (max-width: 1030px) {
    min-width: 15.5rem;
  }
`;

export const MoreInformationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const MoreInformationUser = styled.div`
  background: ${({ theme }) => theme.colors.background};
  min-height: 200px;
  width: 400px;
  max-height: 400px;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0px 8px 24px rgba(0,0,0,0.15);
  z-index: 1000;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid rgba(0,0,0,0.1);
  
  @media (max-width: 768px) {
    width: 280px;
    padding: 0.8rem;
    min-height: 180px;
    max-height: 350px;
  }
  
  @media (max-width: 534px) {
    width: 90vw;
    max-width: 260px;
    padding: 0.6rem;
    min-height: 160px;
    max-height: 300px;
  }
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.2);
    border-radius: 2px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    flex-shrink: 0;

    h1 {
      font-size: 0.9rem !important;
      margin: 0 !important;
      color: ${({ theme }) => theme.colors.secondary};
      
      @media (max-width: 768px) {
        font-size: 0.8rem !important;
      }
      
      @media (max-width: 534px) {
        font-size: 0.75rem !important;
      }
    }

    .headerPhotoName {
      display: flex;
      gap: 0.4rem;
      align-items: center;
      
      @media (max-width: 534px) {
        gap: 0.3rem;
      }
      
      img {
        width: 2rem !important;
        height: 2rem !important;
        
        @media (max-width: 768px) {
          width: 1.8rem !important;
          height: 1.8rem !important;
        }
        
        @media (max-width: 534px) {
          width: 1.5rem !important;
          height: 1.5rem !important;
        }
      }
    }
  }

  .card-infos {
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    gap: 0.3rem;
    
    @media (max-width: 768px) {
      padding: 0.1rem;
      gap: 0.2rem;
    }
    
    @media (max-width: 534px) {
      padding: 0;
      gap: 0.1rem;
    }

    .service-infos {
      display: flex;
      justify-items: center;
      margin: 0;
      gap: 0.3rem;

      .diamondCard-infos {
        img {
          display: flex;
          max-width: 1.5rem;
          max-height: 1.5rem;
          margin: 0;
          
          @media (max-width: 768px) {
            max-width: 1.3rem;
            max-height: 1.3rem;
          }
          
          @media (max-width: 534px) {
            max-width: 1.1rem;
            max-height: 1.1rem;
          }
        }
      }

      .servicesCard-infos {
        display: flex;
        margin: 0;
        align-items: center;
        gap: 0.2rem;

        .numberServices {
          color: ${({ theme }) => theme.colors.primary};
          font-size: 0.8rem;
          
          @media (max-width: 534px) {
            font-size: 0.7rem;
          }
        }

        .labelCorrespondence {
          color: ${({ theme }) => theme.colors.gray_300};
          font-size: 0.8rem;
          
          @media (max-width: 534px) {
            font-size: 0.7rem;
          }
        }
      }
    }

    .title {
      margin: 0.2rem 0;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.primary};
      font-size: 0.85rem;
      
      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
      
      @media (max-width: 534px) {
        font-size: 0.75rem;
      }
    }

    .content {
      color: ${({ theme }) => theme.colors.gray_300};
      letter-spacing: 0px;
      opacity: 1;
      max-height: 8rem;
      overflow-y: auto;
      margin: 0;
      font-size: 0.8rem;
      line-height: 1.3;
      
      @media (max-width: 768px) {
        max-height: 6rem;
        font-size: 0.75rem;
      }
      
      @media (max-width: 534px) {
        max-height: 5rem;
        font-size: 0.7rem;
      }
      
      &::-webkit-scrollbar {
        width: 3px;
      }
      
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(0,0,0,0.2);
        border-radius: 2px;
      }
    }
  }


  .main {
    width: 100%;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text_gray};
  }

  .servicesProvided {
    display: flex;
    gap: 0.2rem;
    margin: 0.5rem 0;
    align-items: center;
  }

  .presentationUser {
    margin-left: 0.4rem;
    h2 {
      font-size: 1.5rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.primary};
    }

    p {
      color: ${({ theme }) => theme.colors.gray_300};
      letter-spacing: 0px;
      opacity: 1;
      max-height: 11rem;
      overflow-y: scroll;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  @media (max-width: 380px) {
    min-width: 15rem;
    max-width: 15rem;
  }

  @media (max-width: 325px) {
    min-width: 14rem;
    max-width: 14rem;
  }
`;
